import { EuiPageTemplate, EuiButton } from "@inscopix/ideas-eui";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";

export const CreatePersonalSpaceError = () => {
  const routeMap = useRouteMapContext((s) => s.routeMap);
  return (
    <EuiPageTemplate.EmptyPrompt
      title={<span>Something went wrong</span>}
      iconType={"warning"}
      color="danger"
      footer={
        <EuiButton fill onClick={() => routeMap.DASHBOARD.navigateTo()}>
          Go to your dashboard
        </EuiButton>
      }
    >
      Sorry, it looks like we were not able to create your space at this time.
      This issue has been logged and reported.
    </EuiPageTemplate.EmptyPrompt>
  );
};
